import * as React from 'react';
import ScrollableAnchor from 'react-scrollable-anchor';
import { Container } from 'reactstrap';
import './TermsAndConditions.css';

export interface ITermsAndConditionsProps {
    image_path: string;
    data: any;
    colors: any;
}

export const TermsAndConditions = (props: ITermsAndConditionsProps) => (
    <div style={{ margin: 20 }}>
        <ScrollableAnchor id='terms'>
            <div>
                <Container
                    className='d-flex flex-column justify-content-center'
                    style={{
                        background: 'rgba(255, 255, 255, 0.65)',
                        borderRadius: 20,
                        margin: '30px auto',
                        maxWidth: 970,
                        padding: '16px 24px',
                    }}
                >
                    <h3 className='TermsTitle' style={{ color: props.colors.dark }}>{props.data.shipping.title}</h3>
                    <img src={props.image_path + props.data.shipping.steps} style={{ width: '100%' }} className='Steps align-self-center' />
                    <div style={{ padding: '16px 0' }}>
                        <ol className='TermsItem'>
                            {props.data.shipping.items.map((x: string, i: number) => (
                                <li dangerouslySetInnerHTML={{ __html: x }} key={i} />
                            ))}
                        </ol>
                    </div>
                    <h3 className='TermsTitle' style={{ color: props.colors.dark }}>{props.data.warranty.title}</h3>
                    <div style={{ padding: '4px 0 16px 0' }}>
                        <ol className='TermsItem'>
                            {props.data.warranty.items.map((x: string, i: number) => (
                                <li dangerouslySetInnerHTML={{ __html: x }} key={i} />
                            ))}
                        </ol>
                    </div>
                    <h3 className='TermsTitle' style={{ color: props.colors.dark }}>{props.data.terms.title}</h3>
                    <div style={{ padding: '4px 0 16px 0' }}>
                        <ol className='TermsItem'>
                            {props.data.terms.items.map((x: string, i: number) => (
                                <li dangerouslySetInnerHTML={{ __html: x }} key={i} />
                            ))}
                        </ol>
                    </div>
                </Container>
            </div>
        </ScrollableAnchor>
    </div>
);


// WEBPACK FOOTER //
// ./src/pages/Home/TermsAndConditions/index.tsx